import { formatDateTime, relativeTime } from '../../lib/format';
import { Tooltip } from './Tooltip';

/**
 * "acum 3 zile" with the exact date and time on hover.
 *
 * The relative form is what people scan, but it stops being useful past a
 * day or two — "acum 3 zile" does not say whether a comment landed Monday
 * morning or Tuesday night. Hovering (or focusing) shows the full moment in the
 * app's own tooltip; the `dateTime` attribute keeps the machine-readable value
 * on the element for anyone reading the DOM. Deliberately not focusable: a tab
 * stop on every timestamp would make long activity lists tedious to move through.
 */
export function RelativeTime({ iso, className }: { iso: string; className?: string }) {
  return (
    <Tooltip label={formatDateTime(iso)}>
      <time dateTime={iso} className={className}>
        {relativeTime(iso)}
      </time>
    </Tooltip>
  );
}
